import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="py-24 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-4 md:px-6">
        <h1 className="font-display text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-8">
          Politique de Confidentialité
        </h1>
        
        <div className="prose prose-lg dark:prose-invert max-w-none">
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Introduction</h2>
            <p>
              Chez MGE COUVERTURE, nous accordons une grande importance à la protection de vos données personnelles. Cette politique de confidentialité vous informe sur la manière dont nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre site web et nos services.
            </p>
            <p>
              En utilisant notre site, vous consentez à notre politique de confidentialité. Nous nous réservons le droit de modifier cette politique à tout moment. Toute modification sera publiée sur cette page.
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Données collectées</h2>
            <p>
              Nous pouvons collecter les types d'informations suivants :
            </p>
            <ul>
              <li>Informations personnelles : nom, prénom, adresse email, numéro de téléphone, adresse postale</li>
              <li>Informations techniques : adresse IP, type de navigateur, fournisseur d'accès à Internet, pages de référence/sortie, système d'exploitation, horodatage, parcours de navigation</li>
              <li>Informations de communication : messages que vous nous envoyez via notre formulaire de contact</li>
            </ul>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Utilisation des données</h2>
            <p>
              Nous utilisons vos données personnelles pour :
            </p>
            <ul>
              <li>Vous fournir nos services et répondre à vos demandes</li>
              <li>Améliorer notre site web et nos services</li>
              <li>Vous envoyer des communications marketing (avec votre consentement)</li>
              <li>Respecter nos obligations légales et réglementaires</li>
            </ul>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Cookies</h2>
            <p>
              Notre site utilise des cookies pour améliorer votre expérience de navigation. Un cookie est un petit fichier placé sur votre appareil qui nous aide à comprendre et à enregistrer vos préférences pour de futures visites.
            </p>
            
            <h3 className="font-heading text-xl font-semibold mt-6 mb-3">Types de cookies que nous utilisons</h3>
            <ul className="list-disc pl-6 mb-4">
              <li><strong>Cookies essentiels :</strong> Nécessaires au fonctionnement du site. Ils vous permettent de naviguer sur notre site et d'utiliser ses fonctionnalités.</li>
              <li><strong>Cookies de performance :</strong> Nous aident à comprendre comment les visiteurs interagissent avec notre site en collectant et rapportant des informations de manière anonyme.</li>
              <li><strong>Cookies de fonctionnalité :</strong> Permettent au site de se souvenir des choix que vous faites (comme votre nom d'utilisateur, votre langue ou la région où vous vous trouvez) et offrent des fonctionnalités améliorées et plus personnelles.</li>
              <li><strong>Cookies de ciblage :</strong> Enregistrent votre visite sur notre site, les pages que vous avez visitées et les liens que vous avez suivis. Nous utilisons ces informations pour rendre notre site et les publicités qui y sont affichées plus pertinents par rapport à vos intérêts.</li>
            </ul>
            
            <h3 className="font-heading text-xl font-semibold mt-6 mb-3">Gestion des cookies</h3>
            <p>
              Lors de votre première visite sur notre site, une bannière de consentement aux cookies vous informe de l'utilisation des cookies et vous demande votre consentement. Vous pouvez à tout moment modifier vos préférences en matière de cookies.
            </p>
            <p>
              Vous pouvez également configurer votre navigateur pour refuser tous les cookies ou pour être averti lorsqu'un cookie est envoyé. Pour savoir comment gérer les cookies dans votre navigateur, consultez la documentation de celui-ci :
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/fr/kb/protection-renforcee-contre-pistage-firefox" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Safari</a></li>
              <li><a href="https://support.microsoft.com/fr-fr/microsoft-edge/supprimer-les-cookies-dans-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Microsoft Edge</a></li>
            </ul>
            <p>
              Veuillez noter que certaines fonctionnalités du site peuvent ne pas fonctionner correctement si vous désactivez les cookies.
            </p>
            
            <h3 className="font-heading text-xl font-semibold mt-6 mb-3">Durée de conservation des cookies</h3>
            <p>
              La durée de conservation des cookies varie selon leur type :
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li><strong>Cookies de session :</strong> Temporaires et supprimés lorsque vous fermez votre navigateur.</li>
              <li><strong>Cookies persistants :</strong> Restent sur votre appareil jusqu'à leur expiration ou jusqu'à ce que vous les supprimiez manuellement. La durée de conservation de nos cookies persistants est de 150 jours maximum.</li>
            </ul>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Partage des données</h2>
            <p>
              Nous ne vendons, n'échangeons ni ne transférons vos informations personnelles à des tiers sans votre consentement, sauf lorsque cela est nécessaire pour fournir un service que vous avez demandé ou lorsque nous sommes légalement tenus de le faire.
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Sécurité des données</h2>
            <p>
              Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données personnelles contre tout accès, altération, divulgation ou destruction non autorisés.
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Vos droits</h2>
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants concernant vos données personnelles :
            </p>
            <ul>
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification de vos données</li>
              <li>Droit à l'effacement de vos données</li>
              <li>Droit à la limitation du traitement</li>
              <li>Droit à la portabilité des données</li>
              <li>Droit d'opposition au traitement</li>
            </ul>
            <p>
              Pour exercer ces droits, veuillez nous contacter à l'adresse email suivante : privacy@mgecouverture.fr
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Contact</h2>
            <p>
              Si vous avez des questions concernant cette politique de confidentialité, vous pouvez nous contacter :
            </p>
            <p>
              <strong>Par email :</strong> contact@mgecouverture.fr<br />
              <strong>Par téléphone :</strong> 01 23 45 67 89<br />
              <strong>Par courrier :</strong> MGE COUVERTURE, 123 Avenue de la Construction, 75001 Paris<br />
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
